import React, { useMemo, useState } from "react";
import { Toast } from "react-bootstrap";
import SubjectImage from "../../Components/SubjectImage/SubjectImage";
import IconButton from "../../Components/Buttons/IconButton";
import { getToastPresentation } from "./toastPresentation";

const ToastItem = React.memo(function ToastItem({
  toast,
  userData,
  removeToast,
  onClose,
  navigate,
}) {
  const [isHovered, setIsHovered] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);

  const computed = useMemo(
    () => getToastPresentation(toast, userData),
    [
      toast,
      userData?.entityAssets?.alertStates,
      userData?.entityInformation?.entityPreference,
    ],
  );

  const {
    colorStyle,
    priorityDescription,
    showBelowSubjectName,
    displayName,
    imageUrl,
    fallbackImageSrc,
  } = computed;

  if (toast.category === "Critical") return null;

  const subjectName = displayName !== "--" ? displayName : null;

  const openSubject = (e) => {
    e.stopPropagation();
    navigate(`/user/dashboard/subject/${toast?.documentInfo?.id}`);
    onClose(e, toast.id);
  };

  const dismiss = (e) => {
    e.stopPropagation();
    onClose(e, toast.id);
  };

  return (
    <Toast
      onClose={() => removeToast(toast.id)}
      autohide={!isHovered && !hasFocus}
      delay={userData?.entityInformation?.alertPreferences?.popupsDelay || 5000}
      className="status-change-container"
      style={{ zIndex: 1000, cursor: "pointer" }}
      onClick={openSubject}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setHasFocus(true)}
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) setHasFocus(false);
      }}
    >
      <SubjectImage
        imageUrl={imageUrl}
        fallbackSrc={fallbackImageSrc}
        className="status-change-toast-image"
        onError={(e) => {
          if (toast?.documentInfo?.imageUrl) {
            e.target.src = "/svgs/MonitoredSubjectCard/user-circle.svg";
            e.target.className = "status-change-toast-image";
          }
        }}
      />
      <div className="toast-subject-card-information-container">
        <IconButton
          label={
            subjectName ? `Open details for ${subjectName}` : "Open details"
          }
          className="toast-subject-card-name toast-subject-card-open"
          onClick={openSubject}
        >
          {" "}
          {displayName}
        </IconButton>
        <div className="toast-subject-card-id">{showBelowSubjectName}</div>
      </div>
      <div className="d-flex w-100 justify-content-end gap-2">
        <div className="toast-subject-card-status" style={colorStyle}>
          {priorityDescription}
        </div>
        <IconButton
          label={
            subjectName ? `Dismiss alert for ${subjectName}` : "Dismiss alert"
          }
          className="toast-subject-card-dismiss"
          onClick={dismiss}
        >
          <img src="/svgs/Toasts/x-close.svg" alt="" aria-hidden="true" />
        </IconButton>
      </div>
    </Toast>
  );
});

export default ToastItem;
